// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"styles_drawerContainer__Ovl8h"};